import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import type { HomeNextAction } from './homeTypes';
import { normalizeNextActions } from './homeTypes';

interface NextBestActionsProps {
  actions: HomeNextAction[] | unknown[];
  /** When true, skip first action (already shown in garage) */
  skipFirst?: boolean;
}

export const NextBestActions: React.FC<NextBestActionsProps> = ({
  actions,
  skipFirst = true,
}) => {
  const navigate = useNavigate();
  const normalized = normalizeNextActions(actions);
  const list = skipFirst ? normalized.slice(1, 3) : normalized.slice(0, 2);
  if (!list.length) return null;

  return (
    <section className="pb-6" aria-label="Suggested next steps">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {list.map((action) => (
            <li
              key={action.id}
              className="flex items-center justify-between gap-3 border border-white/[0.06] bg-[#0c0c0c]/70 px-4 py-3"
            >
              <div className="min-w-0">
                <p className="text-white text-sm font-medium truncate">{action.title}</p>
                {action.body ? (
                  <p className="text-gray-500 text-xs mt-0.5 line-clamp-1">{action.body}</p>
                ) : null}
              </div>
              <Button type="button" variant="ghost" size="sm" onClick={() => navigate(action.href)}>
                {action.cta_label}
              </Button>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default NextBestActions;
